import type { AddedAddOn } from '@/ducks/addOns/types';
import type { UserData } from '@/helpers/util/cryptoUtil';

export interface CommonTrackingParams {
  addonsValue?: number;
  cabinId: string;
  cabinName: string;
  couponCode?: string | null;
  cruisePrice: number;
  currencyCode: string;
  debarkDate: string;
  discount: number;
  duration: number;
  embarkDate: string;
  itinerary_group: string | null;
  numberPassengers: number;
  packageId: string;
  packageName: string;
  portFees: number;
  ports: string[];
  promotionId?: string;
  promotionName?: string;
  regions: string[] | null;
  shipName: string;
  tax: number;
  totalValue: number;
}

export interface TrackingParamsWithAddOns extends CommonTrackingParams {
  addedAddOns: AddedAddOn[];
}

export interface TrackingParamsWithUser extends TrackingParamsWithAddOns {
  secure: number;
  serviceCharge: number;
  user: UserData;
}

export interface TrackingParamsForCheckout extends TrackingParamsWithAddOns {
  secure: number;
  serviceCharge: number;
}

export interface TrackingEcommerceItem {
  cabin_id?: string;
  cabin_name?: string;
  discount?: number;
  index?: number;
  item_category: string;
  item_id: string;
  item_name: string;
  nights?: number;
  number_passengers?: number;
  ports?: string[];
  price: number;
  promotion_id?: string;
  promotion_name?: string;
  quantity: number;
  related_item_id?: string;
  ship_name?: string;
  travel_dates?: string;
}

export interface TrackingEcommerce {
  currency: string;
  items: TrackingEcommerceItem[];
  tax?: number;
  value?: number;
}

export interface TrackingEventData extends Record<string, string | number | boolean | object | undefined> {
  addons_value?: number;
  coupon_code?: string;
  ecommerce: TrackingEcommerce;
  event: string;
  itinerary_group: string | string[];
  port_fees?: number;
  regions: string[] | string;
  secure?: number;
  service_charge?: number;
  user?: UserData;
}
